var lib_core      = require("lib-core");
var ui_extensions = require("ui-extensions");
var cio_datamodel = require("cio-datamodel");

var SoicSopPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/soicSop/soicSopPadGeneratorInteractionModel.js");
var QuadRowPackageGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/quadRowPackageGeneratorInteractionModel.js");
var QfnPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/qfn/qfnPadGeneratorInteractionModel.js");
var Sot23PadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/sot/sot23PadGeneratorInteractionModel.js");
var Sot223PadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/sot/sot223PadGeneratorInteractionModel.js");
var Sot143PadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/sot/sot143PadGeneratorInteractionModel.js");
var SotflPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/sot/sotflPadGeneratorInteractionModel.js");
var DualRowPackageWithDifferentPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/dualRowPackageWithDifferentPadGeneratorInteractionModel.js");
var ToDpakPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/todpak/toDpakPadGeneratorInteractionModel.js");
var ChipPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/chip/chipPadGeneratorInteractionModel.js");
var MoldedBodyPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/moldedBody/moldedBodyPadGeneratorInteractionModel.js");
var SodflPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/sodfl/sodflPadGeneratorInteractionModel.js");
var Dfn2PadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/dfn/dfn2PadGeneratorInteractionModel.js");
var Dfn3PadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/dfn/dfn3PadGeneratorInteractionModel.js");
var Dfn4PadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/dfn/dfn4PadGeneratorInteractionModel.js");
var ECapPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/e-cap/eCapPadGeneratorInteractionModel.js");
var CrystalPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/crystal/crystalPadGeneratorInteractionModel.js");
var BgaPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/bga/bgaPadGeneratorInteractionModel.js");
var MelfPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/melf/melfPadGeneratorInteractionModel.js");
var ChipArrayFourSideFlatConcavePadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/chipArray/chipArrayFourSideFlatConcavePadGeneratorInteractionModel.js");
var ChipArrayTwoSideConvexPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/chipArray/chipArrayTwoSideConvexPadGeneratorInteractionModel.js");
var ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/chipArray/chipArrayTwoSideFlatConcavePadGeneratorInteractionModel.js");
var PlccPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/plcc/plccPadGeneratorInteractionModel.js");
var OscillatorCornerConcavePadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/oscillator/oscillatorCornerConcavePadGeneratorInteractionModel.js");
var OscillatorJLeadPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/oscillator/oscillatorJLeadPadGeneratorInteractionModel.js");
var DualRowPackageWithJOrLLeadPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/dualRowPackageWithJOrLLeadPadGeneratorInteractionModel.js");
var SojPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/soj/sojPadGeneratorInteractionModel.js");
var SodPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/sod/sodPadGeneratorInteractionModel.js");
var AxialPadGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/axialPadGeneratorInteractionModel.js");
var DipPadGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/dipPadGeneratorInteractionModel.js");
var HeaderStraightGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/headerStraightGeneratorInteractionModel.js");
var HeaderRightAngleGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/headerRightAngleGeneratorInteractionModel.js");
var HeaderStraightSocketGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/headerStraightSocketGeneratorInteractionModel.js");
var HeaderRightAngleSocketGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/headerRightAngleSocketGeneratorInteractionModel.js");
var SonGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/son/sonPadGeneratorInteractionModel.js");
var RadialRoundPadGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/radialRoundPadGeneratorInteractionModel.js");
var RadialLedRoundPadGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/radialLedRoundPadGeneratorInteractionModel.js");
var CrystalHC49PadGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/crystalHC49PadGeneratorInteractionModel.js");
var FemaleStandoffSpacerGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/femaleStandoffSpacerGeneratorInteractionModel.js");
var MaleFemaleStandoffSpacerGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/maleFemaleStandoffSpacerGeneratorInteractionModel.js");
var SnapLockGeneratorInteractionModel = require("./ipcPthGeneratorInteractionModels/snapLockGeneratorInteractionModel.js");
var ChipLedPadGeneratorInteractionModel = require("./ipcSmdGeneratorInteractionModels/chip/chipLedPadGeneratorInteractionModel.js");

var PackageGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
	lib_core.Model.call(this);
    this.parametricData = parametricData;
    this.ipcGeneratorIM = null;
    this.userSettingsModel = userSettingsModel;
    this.showFootprintParams = showFootprintParams;
	this.withCustomFootprintParams = withCustomFootprintParams;
    this.initialize();
};

lib_core.inherit(PackageGeneratorInteractionModel, lib_core.Model);
PackageGeneratorInteractionModel.$class = "PackageGeneratorInteractionModel";
module.exports = PackageGeneratorInteractionModel;

PackageGeneratorInteractionModel.prototype.initialize = function() {
	//assign im depends on IPC package type
	switch(this.parametricData.constructor) {
		case cio_datamodel.IpcDataModel.SoicSopData:
		case cio_datamodel.IpcDataModel.CfpData:
			this.ipcGeneratorIM = new SoicSopPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.SodData:
			this.ipcGeneratorIM = new SodPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.QfpData:
		case cio_datamodel.IpcDataModel.CqfpData:
			this.ipcGeneratorIM = new QuadRowPackageGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.QfnData:
			this.ipcGeneratorIM = new QfnPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.Sot23Data:
			this.ipcGeneratorIM = new Sot23PadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.SotflData:
			this.ipcGeneratorIM = new SotflPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.Sot223Data:
			this.ipcGeneratorIM = new Sot223PadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.Sot143Data:
			this.ipcGeneratorIM = new Sot143PadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.ToDpakData:
			this.ipcGeneratorIM = new ToDpakPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.ChipData:
			this.ipcGeneratorIM = new ChipPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.MoldedBodyData:
			this.ipcGeneratorIM = new MoldedBodyPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.SodflData:
			this.ipcGeneratorIM = new SodflPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.Dfn2Data:
			this.ipcGeneratorIM = new Dfn2PadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.Dfn3Data:
			this.ipcGeneratorIM = new Dfn3PadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.Dfn4Data:
			this.ipcGeneratorIM = new Dfn4PadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.AluminumElectrolyticData:
			this.ipcGeneratorIM = new ECapPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.CrystalData:
			this.ipcGeneratorIM = new CrystalPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.BgaData:
			this.ipcGeneratorIM = new BgaPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.MelfData:
			this.ipcGeneratorIM = new MelfPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.ChipArrayTwoSideFlatConcaveData:
			this.ipcGeneratorIM = new ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.ChipArrayTwoSideConvexData:
			this.ipcGeneratorIM = new ChipArrayTwoSideConvexPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.ChipArrayFourSideFlatConcaveData:
			this.ipcGeneratorIM = new ChipArrayFourSideFlatConcavePadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.PlccData:
			this.ipcGeneratorIM = new PlccPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.OscillatorCornerConcaveData:
			this.ipcGeneratorIM = new OscillatorCornerConcavePadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.OscillatorJLeadData:
			this.ipcGeneratorIM = new OscillatorJLeadPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.OscillatorLBendData:
			this.ipcGeneratorIM = new DualRowPackageWithJOrLLeadPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.SojData:
			this.ipcGeneratorIM = new SojPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.AxialData:
			this.ipcGeneratorIM = new AxialPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.DipData:
			this.ipcGeneratorIM = new DipPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.HeaderStraightData:
			this.ipcGeneratorIM = new HeaderStraightGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.HeaderRightAngleData:
			this.ipcGeneratorIM = new HeaderRightAngleGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.HeaderStraightSocketData:
			this.ipcGeneratorIM = new HeaderStraightSocketGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.HeaderRightAngleSocketData:
			this.ipcGeneratorIM = new HeaderRightAngleSocketGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.SonData:
			this.ipcGeneratorIM = new SonGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.RadialRoundData:
			this.ipcGeneratorIM = new RadialRoundPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.RadialLedRoundData:
			this.ipcGeneratorIM = new RadialLedRoundPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.CrystalHC49Data:
			this.ipcGeneratorIM = new CrystalHC49PadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.FemaleStandoffSpacerData:
			this.ipcGeneratorIM = new FemaleStandoffSpacerGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.MaleFemaleStandoffSpacerData:
			this.ipcGeneratorIM = new MaleFemaleStandoffSpacerGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.SnapLockData:
			this.ipcGeneratorIM = new SnapLockGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams);
		break;

		case cio_datamodel.IpcDataModel.ChipLedData:
			this.ipcGeneratorIM = new ChipLedPadGeneratorInteractionModel(this.parametricData, this.userSettingsModel, this.showFootprintParams, this.withCustomFootprintParams);
		break;
	};
};

PackageGeneratorInteractionModel.prototype.getInspectorElements = function() {
	console.assert(this.ipcGeneratorIM, "IPC generator IM missing.");
	return this.ipcGeneratorIM.getInspectorElements();
};
